import { createContext, useContext } from 'react';

// The URL of the report being viewed (undefined before any scan). Provided once
// at the page level so each section's CommentThread needs only an `anchor`,
// rather than every view and sub-component threading the URL down.
export const CommentsUrlContext = createContext<string | undefined>(undefined);

export const useCommentsUrl = () => useContext(CommentsUrlContext);
